import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRole } from "@/hooks/useRole";
import { usePlayerProfile } from "@/hooks/usePlayerProfile";

interface ProfileSectionProps {
  isCollapsed: boolean;
}

export const ProfileSection: React.FC<ProfileSectionProps> = ({ isCollapsed }) => {
  const { user } = useRole();
  const { socialMedia } = usePlayerProfile();

  // Debug logs para verificar se a imagem está chegando
  console.log('🖼️ [PlayerSidebarProfile] Social media data:', socialMedia);
  console.log('🖼️ [PlayerSidebarProfile] Image URL:', socialMedia?.image_url);

  return (
    <div className={`px-3 py-4 ${isCollapsed ? 'items-center' : ''} flex flex-col`}>
      <div className={`flex ${isCollapsed ? 'justify-center' : 'items-center'} mb-2`}>
        <Avatar className={`${isCollapsed ? 'h-10 w-10' : 'h-12 w-12'} rounded-full border-2 border-[#00B6F0]`}>
          <AvatarImage src={socialMedia?.image_url || "/placeholder.svg"} alt={user?.nickname || "User"} />
          <AvatarFallback className="bg-[#223342] text-[#00B6F0]">
            {user?.nickname?.slice(0, 2) || 'J'}
          </AvatarFallback>
        </Avatar>
        {!isCollapsed && (
          <div className="ml-3">
            <p className="text-white font-medium truncate">{user?.nickname || 'Jogador'}</p>
            <div className="text-xs bg-gradient-to-r from-[#00B6F0] to-[#9f00ff] bg-clip-text text-transparent">Online</div>
          </div>
        )}
      </div>
      
      {!isCollapsed && (
        <div className="w-full px-2 py-1 mb-2 bg-[#212B3B] rounded-md text-center">
          <span className="text-xs text-gray-400">Jogador</span>
        </div>
      )}
    </div>
  );
};
